import { FieldPath, WhereFilterOp } from '@angular/fire/firestore';

export class WhereQueryModel {
    field: string | FieldPath;
    opStr: WhereFilterOp;
    compareValue: any;
}

export type WhereQuery = WhereQueryModel | undefined;
